// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"7d2129f5","176":"88ef083c","325":"d683bcfc","337":"f7816deb","457":"7c611218","670":"90686d7e","724":"8aa2379d","824":"feba612f","853":"2e18387c"}[chunkId] + ".chunk.js";
};